import { ifItemExists } from '../utils/ifItemExists';
const videos = document.querySelectorAll('video');

const checkWindowWidth = () => {
  const sm = 640;
  return window.innerWidth < sm ? 'sm' : 'xl';
};

const initVideosSrc = () => {
  videos?.forEach((video) => {
    const deviceSize = checkWindowWidth();
    const videoSrc = {
      sm: video.dataset.mobileVid,
      xl: video.dataset.desktopVid,
    };

    video.setAttribute('src', videoSrc[deviceSize] || videoSrc['xl']);
  });
};

ifItemExists(videos, () => {
  initVideosSrc();
  window.addEventListener('resize', initVideosSrc);
});
